// extracted by mini-css-extract-plugin
module.exports = {"signup-form":"Signup_signup-form__2KxEG","error":"Signup_error__2rvn7"};